import { render } from "./Tele2Banner.vue?vue&type=template&id=02675f67&scoped=true&ts=true"
import script from "./Tele2Banner.vue?vue&type=script&lang=ts"
export * from "./Tele2Banner.vue?vue&type=script&lang=ts"

import "./Tele2Banner.vue?vue&type=style&index=0&id=02675f67&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02675f67"]])

export default __exports__